import { useMutation } from "react-query";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";
import { useApp } from "../../../AppProvider";

export const useTriggerPublishWaterLevels = () => {
  const { getAccessTokenSilently } = useAuth0();
  const { doToast } = useApp();

  const mutation = useMutation(
    async () => {
      const token = await getAccessTokenSilently();
      const headers = { Authorization: `Bearer ${token}` };
      await axios.get(
        `${process.env.REACT_APP_ENDPOINT}/api/publish-data/publish-water-levels`,
        { headers }
      );
    },
    {
      onSuccess: () =>
        doToast(
          "success",
          "Water levels publish initiated! Please refresh the page after 1 minute to see your changes."
        ),
      onError: (error) => {
        const message =
          error?.response?.data?.message ||
          "Failed to publish water levels. Please try again or contact LRE Water for assistance.";
        doToast("error", message);
      },
    }
  );

  return {
    triggerPublish: mutation.mutate,
    isLoading: mutation.isLoading,
    isError: mutation.isError,
  };
};
